import 'babel-polyfill';
require('./bootstrap');

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue';
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'
import App from '~/components/App'
// import CKEditor from '@ckeditor/ckeditor5-vue';

Object.assign = require('object-assign')

Vue.use(BootstrapVue);
// Vue.use(CKEditor);

import '~/plugins'
import '~/components'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    i18n,
    store,
    router,
    BootstrapVue,
    // CKEditor,
    ...App
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js